<div
    #wrapper
    class="row">
    <div class="col-md-12 stretch-card grid-margin grid-margin-md-2">
        <div class="card data-icon-card-{{ type }}">
            <div class="card-body">
                <div class="row">
                    <div [ngClass]="disableClose ? 'col-12' : 'col-10'" class="text-white">
                        <i *ngIf="icon && icon.length > 0" class="main-icon {{ icon }}"></i>
                        <h3 *ngIf="title && title.length > 0">{{ title }}</h3>
                        <p class="main-text text-white font-weight-light mb-0">
                            <span [ngStyle]="{fontSize: fontSize}">{{ message }}</span>
                            <button
                                    *ngIf="btnLink"
                                    routerLink="{{ btnLink }}"
                                    class="btn btn-light btn-rounded btn-fw action-btn"
                                    type="button">
                                {{ btnTitle }}
                            </button>
                            <button
                                    *ngIf="btnCallback"
                                    (click)="btnCallback(callbackParent)"
                                    class="btn btn-light btn-rounded btn-fw action-btn"
                                    type="button">
                                {{ btnTitle }}
                            </button>
                        </p>
                    </div>
                    <div
                            *ngIf="disableClose === false"
                            (click)="hideAlert()"
                            class="col-2 close-icon background-icon"><i class="ti-close"></i></div>
                </div>
            </div>
        </div>
    </div>
</div>
